export default "__VITE_ASSET__402baaf5__"